import fetchRates from './repository/fetchRates';

export const createExchange = repository => (
  async () => (repository.fetchRates())
);

export default createExchange({
  fetchRates,
});
